export const GA_EVENT_NAMES = {
  login: {
    tabSelected: {
      phone: 'start_phone',
      email: 'start_email',
    },
    toSignup: 'signup',
    success: { email: 'login_email', phone: 'login_phone' },
  },
  signup: {
    success: 'signup_complete_click',
  },
  resetPassword: {
    success: 'password_reset_success',
    submit: 'password_reset_code_click',
  },
};

export const GA_ROUTES = {
  login: 'login',
  signup: 'signup',
  orderList: {
    newOrder: 'order_list_new',
    readyToShip: 'order_list_ready',
    shipping: 'order_list_shipping',
    delivered: 'order_list_shipping_done',
    cancel: 'order_list_cancel',
    exchange: 'order_list_exchange',
    return: 'order_list_return',
  },
  resetPassword: 'password_reset',
};
